/// <reference types="./ConnectionUtils.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { resolvePagingCursors } from '../search/Paging.js';
import { assertExhaustive } from './AssertUtils.js';
export function addConnectionPagingFilter(database, sql, paging, cursorType, reverse, addPagingColumns) {
    const cursorsResult = resolvePagingCursors(database, cursorType, paging);
    if (cursorsResult.isError())
        return cursorsResult;
    const resolvedCursors = cursorsResult.value;
    if (resolvedCursors.after !== null) {
        const operator = reverse ? '<' : '>';
        addCursorNameOperatorAndValue(sql, operator, paging.afterInclusive, resolvedCursors.after, addPagingColumns);
    }
    if (resolvedCursors.before !== null) {
        const operator = reverse ? '>' : '<';
        addCursorNameOperatorAndValue(sql, operator, paging.beforeInclusive, resolvedCursors.before, addPagingColumns);
    }
    return ok(undefined);
}
function addCursorNameOperatorAndValue(sql, operator, orEqual, value, addPagingColumns) {
    sql `AND `;
    addPagingColumns(sql);
    switch (operator) {
        case '>':
            if (orEqual)
                sql `>=`;
            else
                sql `>`;
            break;
        case '<':
            if (orEqual)
                sql `<=`;
            else
                sql `<`;
            break;
        default:
            assertExhaustive(operator);
    }
    sql `${value}`;
}
export function addConnectionOrderByAndLimit(sql, paging, reverse, addPagingColumns) {
    sql `ORDER BY`;
    addPagingColumns(sql);
    let ascending = !reverse;
    if (!paging.forwards)
        ascending = !ascending;
    const countToRequest = paging.count + 1; // request one more to calculate hasMore
    if (!ascending)
        sql `DESC`;
    sql `LIMIT ${countToRequest}`;
}
export function resolveConnectionPagingAndOrdering(paging, rows) {
    const hasMore = rows.length > paging.count;
    const edges = [...rows];
    if (hasMore) {
        edges.splice(paging.count, 1);
    }
    if (!paging.forwards) {
        // Reverse since DESC order returns the rows in the wrong order, we want them in the same order as for forwards pagination
        edges.reverse();
    }
    return { hasMore, edges };
}
//# sourceMappingURL=ConnectionUtils.js.map